// @ts-nocheck
export const ROLE_LABELS = {
  guest: { label: "Guest", description: "Unverified access" },
  pending: { label: "Pending", description: "Account requested, awaiting approval" },
  standard: { label: "Standard", description: "Approved portal user" },
  support: { label: "Support Admin", description: "AvSight support representative with case management" },
  employee: { label: "Employee", description: "AvSight internal employee with enhanced search" },
};

export function hasRole(roles, role) {
  return Array.isArray(roles) && roles.includes(role);
}

/**
 * validate-login / verify envelopes vary: roles may be on the root or under `data`.
 */
/**
 * The caller's accounts + active selection from a validate-login payload (ACOP-79).
 *
 * Sibling of extractRolesFromSessionPayload and deliberately sourced the same way: the session
 * payload is refreshed on every load, whereas localStorage `reqData` is only written during the
 * login flow and is empty on a normal page load.
 */
export function extractAccountsFromSessionPayload(payload) {
  if (!payload || typeof payload !== "object") return null;
  const source =
    Array.isArray(payload.accounts) ? payload
      : payload.data && typeof payload.data === "object" && Array.isArray(payload.data.accounts) ? payload.data
      : null;
  if (!source) return null;
  return {
    accounts: source.accounts,
    selectedAccountId: source.selectedAccountId,
  };
}

export function extractRolesFromSessionPayload(payload) {
  if (!payload || typeof payload !== "object") return null;
  if (Array.isArray(payload.roles)) return payload.roles;
  if (
    payload.data &&
    typeof payload.data === "object" &&
    Array.isArray(payload.data.roles)
  ) {
    return payload.data.roles;
  }
  return null;
}
